import { frontendURL } from '../../../../helper/URLHelper';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/llm-keys'),
      name: 'settings_llm_keys',
      component: Index,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
